module.exports = __webpack_public_path__ + "static/toggl-track-poster-c4f7f1ccef2586ce19332797061285d7.png";